import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getQuestionsRequest } from "../services/apiService";

const initialState = {
  feedbackQues: [],
  isLoader: false,
  error: "",
  count: 0,
  page: 0,
  role: "",
  unit: "",
};

export const getFeedbackQues = createAsyncThunk(
  "retrieve/feedbackQuesion",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getQuestionsRequest(payload);
      return response;
    } catch (error: any) {
      throw rejectWithValue(error.message)
    }
  }
);

// Then, handle actions in your reducers:
const feedbackQuestionSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getFeedbackQues.pending, (state, action) => {
        state.isLoader = true
      })
      .addCase(getFeedbackQues.fulfilled, (state: any, action: any) => {
        const { payload } = action;
        state.feedbackQues = payload.data
        state.count = payload.count
        state.page = payload.page
        state.isLoader = false
        state.role = payload.question_set_for
        state.unit = payload.unit
        sessionStorage.setItem('fbQuestionCount', JSON.stringify(payload.count));
      })
      .addCase(getFeedbackQues.rejected, (state: any, action) => {
        const { payload } = action;
        state.isLoader = false
        state.error = payload
      })
  },
});

const { reducer } = feedbackQuestionSlice;
export default reducer;